__turbopack_context__.v({
  "body": "ParagraphInfoNotice-module__1BifTW__body",
  "card": "ParagraphInfoNotice-module__1BifTW__card",
  "heading": "ParagraphInfoNotice-module__1BifTW__heading",
  "iconBox": "ParagraphInfoNotice-module__1BifTW__iconBox",
  "section": "ParagraphInfoNotice-module__1BifTW__section",
  "text": "ParagraphInfoNotice-module__1BifTW__text",
});
